<template>
  <div class="viq-chat">
    <ViqMessageList />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ViqChatPanel",
  components: {
    ViqMessageList: () => import("./ViqMessageList"),
  },
  computed: {
    ...mapState("Viq", ["activeConversation", "messages"]),
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-chat {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
</style>
